import {
  EKwikUIInputRadioOrientation,
  EKwikUIInputRadioSize
} from "./input-radio.definitions";

export const DEFAULT_VALUES = {
  label: "",
  id: "radio-list",
  formControlName: "form_control_radio_list",
  placeholder: "",
  focus: false,
  invalid: false,
  disabled: false,
  size: EKwikUIInputRadioSize.M,
  orientation: EKwikUIInputRadioOrientation.HORIZONTAL,
  items: []
};

export const VALIDATE_KEY_VALUES = {
  label: true,
  id: true,
  formControlName: true,
  placeholder: true,
  focus: true,
  invalid: true,
  disabled: true,
  size: true,
  orientation: true,
  items: true
};
